import { ApiClient, ApiError } from "@/api/ApiClient";

export type ResetInventoryStocksResponse = {
  updatedCount: number;
};

export async function resetInventoryStocks(): Promise<ResetInventoryStocksResponse> {
  const { data, errors } = await ApiClient.mutations.resetInventoryStocksMutation();
  if (errors?.length) {
    throw new ApiError("No fue posible reiniciar el inventario", "API_ERROR", errors);
  }
  if (!data?.ok) {
    throw new Error(data?.error || "No fue posible reiniciar el inventario");
  }
  return { updatedCount: data.updatedCount || 0 };
}

